import { get, post, put, patch, del } from '../http/http';
import login from './login';
import user from './user';
import order from './order';
import group from './group';
import api from './api';
import apply from './apply';
import product from './product';
import flow from './flow';
import access from './access';
import device from './device';
import advancedService from "./advancedService"

const fileConfig = {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
};

// const pushConfig = {
//     headers: {
//         'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
//     }
// };

export default {
  // 登录
  login,
  // 用户
  user,
  // 我的账单
  order,
  // API分组
  group,

  // api
  api,

  // 应用管理
  apply,
  // 产品管理
  product,
  advancedService,
  //  我的额度
  myline: {
    getList: (val) => get('/quota', val), // 查询列表
    gettopLine: (id, val) => put(`/quota/${id}`, val), // 修改额度
    getRuleList: (productId) => get(`/rule/product/${productId}`) // 修改额度
  },
  // 下级账号配额管理
  accountQuota: {
    getList: (val) => get('/account/quota/list', val), // 获取账号产品配额分页列表
    getRecords: (val) => get('/account/quota/product/quota/records', val), // 获取配额分配记录分页列表
    getRemainingQuota: (accountId, productId) =>
      get(`/account/quota/getRemainingQuota/${accountId}/${productId}`), // 获取指定账号产品的可用余额
    adjust: (val) => post('/account/quota/adjust', val), // 调整账号产品配额
    getRevokeInfo: (accountId, productId) =>
      get(`/account/quota/revoke/info/${accountId}/${productId}`), // 获取配额撤回详情
    getRevokeReasons: () => get('/account/quota/revoke/reasons'), // 获取配额撤回原因字典
    revoke: (val) => post('/account/quota/revoke', val) // 撤回账号产品配额
  },
  // 流量控制
  flow,
  // 访问策略
  access,
  //系统管理
  system: {
    getGroup: () => get('/system/group'), //获取用户组
    setGroup: (id) => put(`/space/${id}`), //加入用户组
    createGroup: (val) => post('/system/group', val), //添加用户组
    disableAndstart: (id, val) => put(`/space/disable/${id}`, val), //用户列表 禁用、启动
    usergroupInfo: (id) => get(`/space/account/${id}`), //用户列表详情
    changeGroupInfo: (id, val) => put(`/space/account/${id}`, val), //修改用户列表详情信息
    delGroup: (id) => del(`/system/group/${id}`), //删除用户组
    addCustomerCode: (val) => post('/space/code', val), //新增客户代码
    getCustomerCode: (id) => get(`/space/code/${id}`) //查询客户代码
  },
  // 服务文档与调试
  service: {
    getList: (type, val) => get(`/${type}`, val), // 查询可调试API
    getInfo: (type, val) => get(`/${type}/${val}`), // 获取可调试API详情
    getWordInfo: (val) => get(`/service/${val}`), // 获取可调试API详情
    getWord: () => get('/service') // 获取已发布文档
  },

  // 统计
  statistics: {
    getList: (val) => get('/statistic', val) // 查询列表
  },

  // AMS接口
  ams: {
    getList: (val) => post('/ams/eqp', val), // 查询列表
    getImei: (val) => post('/ams/imei', val), // 判断公司设备imei
    getNetLog: (val) => get('/ams/last-log', val), // 设备网络日志
    getSelfCheck: (val) => get('/ams/self-check', val), // 获取指定imei的自检参数
    getCheckLog: (val) => get('/ams/self-check-log', val), // 获取自检参数日志
    getStatus: (val) => post('/ams/status', val), // 设备实时日志
    getTemperature: (val) => get('/ams/temperature-log', val), // 设备温度日志
    getVol: (val) => get('/ams/voltage-log', val) // 设备电压日志
  },

  // api code
  code: {
    getList: (val) => get('/result-status', val), // 查询列表
    addList: (val) => post('/result-status', val), // 添加
    delList: (val) => del(`/result-status/${val}`), // 删除
    putList: (val) => put(`/result-status/${val.id}`, val), // 编辑
    getCodeList: (val) => get('/result-status/code', val) // 查询code列表
  },

  // deviceAccess
  device,

  // 推送配置
  push: {
    getList: (val) => post('/expr/match_by_user', val), // 查询列表
    addList: (val) => post('/expr/put', val), // 添加
    delList: (val) => post('/expr/del', val), // 删除
    putList: (val) => post('/expr/update', val), // 编辑
    release: (val) => post('/expr/get', val) // 详情
  },

  // deviceLog
  log: {
    getLogList: (val) => get('/logserver/eqp', val), // 获取设备日志
    getHeartList: (val) => get('/logserver/heartbeat', val), // 获取心跳日志
    getProtocol: (val) => get(`/logserver/protocol/${val}`), // 解析协议
    getTrack: (val) => get('/eqp/track', val), // 查询轨迹数据
    delTrack: (val) => del('/eqp/track', val) // 删除轨迹数据
  },

  // 许可证
  license: {
    addLicense: (val) => put('/license', val), // 新增授权申请
    delLicense: (val) => del(`/license/${val.id}`), // 删除授权申请
    // getList: (val) => get('/license/like', val),    // 模糊查询授权
    getInfo: (val) => get('/license', val), // 公司名精确查询授权
    getList: (val) => get('/license/filter', val), // 查询
    approval: (id, val) => patch(`/license/${id}`, val), // 审批/驳回
    authorize: (val) => patch('/license', val), // 校验授权
    modify: (id, val) => patch(`/license/${id}/update`, val), // 修改申请信息
    renewal: (id, val) => patch(`/license/${id}/renew`, val), // 授权续期
    rebind: (id, val) => patch(`/license/${id}/rebind`, val) // 解绑主机
  },
  // 消息服务
  message: {
    getChannel: (val) => get('/channel', val), //获取通道管理信息
    addChannel: (val) => put('/channel', val), //新增通道管理信息
    changeChannel: (val) => patch('/channel', val), //修改通道管理信息
    delChannel: (id) => del(`/channel/${id}`), //新增通道管理信息
    getVoice: (val) => get('/temp', val), //获取语音模板信息
    addVoice: (val) => put('/temp', val), //新增语音模板信息
    changeVoice: (val) => patch('/temp', val), //修改通道管理信息
    delVoice: (id) => del(`/temp/${id}`), //新增通道管理信息
    getTemp: (val) => get('/temp', val), //获取模板信息
    addTemp: (val) => put('/temp', val), //新增模板信息
    changeTemp: (val) => patch('/temp', val), //修改模板信息
    delTemp: (id) => del(`/temp/${id}`), //删除模板信息
    getSign: (val) => get('/sms/sign', val), //查询短信签名
    addSign: (val) => put('/sms/sign', val), //新增短信签名
    changeSign: (id, val) => patch(`/sms/sign/${id}`, val), //修改短信签名
    delSign: (id) => del(`/sms/sign/${id}`), //删除短信签名
    getLimitApp: (val) => get('/limit/app', val), // 应用发送限制列表
    addLimitApp: (val) => post('/limit/app', val), // 添加应用发送限制
    changeLimitApp: (id, val) => put(`/limit/app/${id}`, val), // 修改APP发送限制，通过ID
    delLimitApp: (id) => del(`/limit/app/${id}`), // 修改APP发送限制，通过ID
    getLimit: (val) => get('/limit/normal', val), // 通用发送限制列表
    changeLimit: (id, val) => put(`/limit/normal/${id}`, val) // 修改APP发送限制，通过ID
  },
  // 数据中心
  dataShow: {
    getData1: (val) => get('/statistic/device/sales', val), // 获取设备销量
    getData2: (val) => get('/statistic/device/access', val), // 获取设备接入量
    getData3: (val) => get('/statistic/device/activated', val), // 获取设备激活量
    getData4: (val) => get('/statistic/device/active', val), // 获取设备日活跃量
    getData5: (val) => get('/statistic/device/top10/sales', val), // 获取销量TOP5设备
    getData6: (val) => get('/statistic/device/top10/area', val) // 获取销量TOP5区域
  },
  dataShow2: {
    getOptions: (val) => get('/eqp/statistic/pull-down', val), // 获取筛选选项数据
    getTotal: (val) => get('/eqp/statistic/total', val), // 查询总设备指标数据
    getTotalTop: (val) => get('/eqp/statistic/total/top', val), // 查询总设备指标数据top
    getActivation: (val) => get('/eqp/statistic/activation', val), // 查询设备活跃数据
    getActivationTop: (val) => get('/eqp/statistic/activation/top', val), // 查询设备活跃数据top
    getImport: (val) => get('/eqp/statistic/import', val), // 查询导入设备指标数据
    getImportTop: (val) => get('/eqp/statistic/import/top', val), // 查询导入设备指标数据top
    getOffline: (val) => get('/eqp/statistic/offline', val), // 查询离线设备指标数据
    getOfflineTop: (val) => get('/eqp/statistic/offline/top', val), // 查询离线设备指标数据top
    getNoactivated: (val) => get('/epq/statistic/non-activated', val), // 查询未激活指标数据
    getNoactivatedTop: (val) => get('/epq/statistic/non-activated/top', val), // 查询未激活指标数据top
    getActive: (val) => get('/eqp/statistic/active', val), // 查询激活设备指标数据
    getActiveTop: (val) => get('/eqp/statistic/active/top', val), // 查询激活设备指标数据top
    getRetention: (val, config) => get('/eqp/statistic/retention', val, config) // 查询留存设备指标数据
  },
  // 订单总览
  operation: {
    getOrderList: (val) => get('/order', val), // 订单总览列表
    exportOrder: (val, config) => get('/order/export', val, config) // 导出订单
  },
  // 工单
  workOrder: {
    createWorkOrder: (val, config) =>
      post('/workOrder/create', val, { ...config, ...fileConfig }), // 创建工单
    getWorkOrderList: (val, config) => get('/workOrder/list', val, config), // 查询工单列表
    getWorkOrderDetails: (val, config) => get('/workOrder/info', val, config), // 查询工单详情
    replyMsg: (val, config) => post('/workOrder/reply', val, { ...config, ...fileConfig }), // 回复消息
    workOrderOff: (val, config) => post('/workOrder/off', val, config), // 完结工单
    readMessage: (val, config) => post('/workOrder/readMessage', val, config), // 已读
    getTitle: (val, config) => get('/workOrder/getTitle', val, config), // 查询标题
    checkRole: (val, config) => get('/workOrder/checkRole', val, config), // 查询当前用户角色
    getKaptcha: (val, config) => get('/auth/code', val, config), // 获取图形验证码
    checkStatus: (val, config) => get('/workOrder/checkStatus', val, config), // 查询是否有未读信息
  },
  // 人脸识别
  faceRecognition: {
    getList: (val) => get('/application', val), // 查询列表
    getFaceGroupList: (val) => get('/face-api/face/group/list', val), // 获取用户组列表
    getFaceUser: (val) => get('/face-api/face/user/group/list', val), // 获取用户列表
    getFaceUserInfo: (val) => get('/face-api/face/user/get', val), // 获取对应用户信息
    getUserFace: (val) => get('/face-api/face/user/list', val), // 获取用户人脸列表
    addGroup: (params, val) => post(`/face-api/face/group/add?appKey=${params.appKey}&appSecret=${params.appSecret}&ver=${params.ver}`, val), // 添加用户组
    deleteGroup: (params, val) => post(`/face-api/face/group/delete?appKey=${params.appKey}&appSecret=${params.appSecret}&ver=${params.ver}`, val), // 删除用户组
    addGroupUser: (params, val) => post(`/face-api/face/add?appKey=${params.appKey}&appSecret=${params.appSecret}&ver=${params.ver}`, val), // 添加用户
    deleteGroupUser: (params, val) => post(`/face-api/face/user/delete?appKey=${params.appKey}&appSecret=${params.appSecret}&ver=${params.ver}`, val), // 删除用户
    getOssToken: (val) => get('/base/oss', val), // 获取阿里oss-token
    addUserFace: (params, val) => post(`/face-api/face/add?appKey=${params.appKey}&appSecret=${params.appSecret}&ver=${params.ver}`, val), // 添加用户人脸
  },
  language: {
    getI18nJson: (val, config) => get('/i18n/load', val, config), // 获取指定语言国际化信息
    addI18n: (val, config) => post('/i18n', val, config), // 添加
    getI18nList: (val, config) => get('/i18n/page', val, config), // 获取国际化列表
    editI18n: (val) => put(`/i18n/${val.id}`, val), // 修改
    delI18n: (id) => del(`/i18n/${id}`), // 删除
  },
  // device
};
